import React, { useState } from 'react';
import "./navber.css";
// import logo from ".././assets/logo.png";
// import chat from ".././assets/chat.png";
// import Menu from ".././assets/list.png";
import {Link} from "react-scroll";
import DarkMode from "./DarkMode.js";

const logo= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744655812/logo_gqm7xg.png";
const chat= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744658340/chat_csndyu.png";
const Menu= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744658369/list_arvwrl.png";

function Navber() {

  const [showMenu,setShowmenu]= useState(false);

  return (
    <nav className="navbar">
    <h1 className="logo-txt" duration={500} onClick={() =>{document.getElementById('intro').scrollIntoView({behavior:'smooth'}); }} > <img className="logo" src= {logo} alt="LoGo" /> BID</h1>
    <div className="desktopMenu">
        <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="desktopmenuList">Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className="desktopmenuList">Skills</Link>
        <Link activeClass='active' to='works' spy={true} smooth={true} offset={-50} duration={500} className="desktopmenuList">Works</Link>
        <Link activeClass='active' to='about' spy={true} smooth={true} offset={-50} duration={500} className="desktopmenuList">About</Link>
    </div>

    <div className='darkmodemenu'>
    <DarkMode className="darkmode"/>
    </div>

    <button className="desktopMenuBtn" activeClass='active' to='contact' spy={true} onClick={() => {
      document.getElementById('contact').scrollIntoView({behavior: 'smooth'});
    }}>
       <img src={chat} className="desktopimg" alt="chat" />
       Contact Me 
    </button>

     <img className="mobmenu" src= {Menu} alt="menu" onClick={()=> setShowmenu(!showMenu)} />
    <div className="navMenu" style={{display: showMenu? 'flex':'none'}}>
    {/* <DarkMode className="darknavmenu"/> */}

        <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="navmenuList"onClick={()=>setShowmenu(false)}>Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className="navmenuList"onClick={()=>setShowmenu(false)}>Skills</Link>
        <Link activeClass='active' to='works' spy={true} smooth={true} offset={-50} duration={500} className="navmenuList"onClick={()=>setShowmenu(false)}>Works</Link>
        <Link activeClass='active' to='about' spy={true} smooth={true} offset={-50} duration={500} className="navmenuList"onClick={()=>setShowmenu(false)}>About</Link>
        <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-50} duration={500} className="navmenuList"onClick={()=>setShowmenu(false)}>Contact</Link>
    </div>

    </nav>
  )
}

export default Navber;
